/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraMisConfigurationsTrendListRequest {
    getFixupPrototypeFunction() { return InfraMisConfigurationsTrendListRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraMisConfigurationsTrendListRequest>): InfraMisConfigurationsTrendListRequest {
        let obj = Object.assign(new InfraMisConfigurationsTrendListRequest(), model);
        InfraMisConfigurationsTrendListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraMisConfigurationsTrendListRequest>): InfraMisConfigurationsTrendListRequest {
        if (!model) return null;
        return InfraMisConfigurationsTrendListRequest.newInstance(<InfraMisConfigurationsTrendListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraMisConfigurationsTrendListRequest) {
        if (!obj) return;

        models.InfraMisConfigurationsTrendListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraMisConfigurationsTrendListRequest): boolean {
        Object.setPrototypeOf(obj, InfraMisConfigurationsTrendListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.InfraMisConfigurationsTrendListRequestFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.InfraMisConfigurationsTrendListFiltersSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.InfraMisConfigurationsTrendListFiltersSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.InfraMisConfigurationsTrendListRequestFilters;

}
